import { RootState } from '@ui/store';

import { getQuoteBuilderOrThrow } from '../utilities/selector-guards';

export const selectQuoteBuilder = (state: RootState) =>
  getQuoteBuilderOrThrow(state.quoteBuilder);
